export default __webpack_public_path__ + "static/media/Style Guide.1e56fe50.pdf";